import React, { useCallback, useEffect, useState } from "react";
import PageContainer from "../components/PageContainer";
import { infographics_mockup } from "./Infographics";
import { useNavigate, useParams } from "react-router-dom";
import { FaDownload } from "react-icons/fa";
import { getDocsManual } from "../api/document";
import { toImagePath } from "../utils/globalFunctions";
import DocLists from "../sections/standards/DocLists";

const sample_pdf = "https://pdfobject.com/pdf/sample.pdf";

const Manual = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [infographicDetail, setInfographicDetail] = useState(null);
  const [otherInfographics, setOtherInfographics] = useState([]);
  const [focusDoc, setFocusDoc] = useState(null);

  const [pageData, setPageData] = useState(null);

  console.log("focusDoc", focusDoc);
  const getData = useCallback(
    () =>
      getDocsManual()
        .then((res) => {
          setPageData(res);
          setFocusDoc(res?.pdfitem[0]);
        })
        .catch((err) => console.log(err)),
    [setPageData]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <PageContainer
      title={pageData?.title ?? "คู่มือหรือมาตรฐานการปฏิบัติงาน"}
      bgImg="/images/docs/infographic-banner.png"
    >
      <section>
        <div className="container mx-auto mt-[-50px] max-w-[800px]">
          <div className="card bg-white shadow-xl mx-auto">
            <div className="card-body min-h-[800px]">
              <div className="flex flex-col gap-10">
                <img
                  src={toImagePath(pageData?.banner?.path)}
                  className="w-full h-auto rounded-lg"
                />

                <iframe
                  src={focusDoc?.pdflink ?? sample_pdf}
                  width="100%"
                  height="600px"
                />
                <div className="flex items-center gap-6">
                  <h6>{focusDoc?.pdftitle}</h6>
                  <button
                    onClick={() => window.open(focusDoc?.pdflink ?? sample_pdf)}
                    className="btn btn-sm text-white btn-error rounded-badge font-light"
                  >
                    <FaDownload />
                    ดาวน์โหลด
                  </button>
                </div>
                <hr />
                <div className="w-full mx-auto">
                  <DocLists
                    docs={pageData?.pdfitem ?? []}
                    keyLabel="pdftitle"
                    onDocClick={(doc) => setFocusDoc(doc)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageContainer>
  );
};

export default Manual;
